import { useI18n } from "@/context/I18nContext";
import { LANGS } from "@/i18n/translations";

export function LanguageSwitcher({ variant }) {
  const { lang, setLang } = useI18n();
  const dark = variant === "dark";
  return (
    <div
      className="inline-flex items-center gap-0.5 p-0.5"
      style={dark ? { background: "rgba(255,255,255,.07)", borderRadius: "9999px" } : { background: "var(--surface-alt)", borderRadius: "var(--radius)" }}
      data-testid="language-switcher"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className="text-xs font-semibold px-2.5 py-1 rounded-full transition-colors"
          style={
            lang === l.code
              ? { background: "var(--accent)", color: "var(--accent-fg)" }
              : { color: dark ? "rgba(245,247,250,.6)" : "var(--text-muted)" }
          }
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
